module.exports = __webpack_public_path__ + "img/koba.71fc68a6.png";